// components/RequirePermission.jsx
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import {
  hasPagePermission,
  isOwnerRouteAllowed,
  isSystemAdminSession,
} from '../utils/accessControl';

const PERMISSIONS_BOOTSTRAP_KEY = 'smart_permissions_bootstrap_pending';
const PERMISSIONS_UPDATED_EVENT = 'smart-permissions-updated';

export default function RequirePermission({ page, anyOf = [], children }) {
  const location = useLocation();
  const [, forceUpdate] = useState(0);
  const [bootstrapping, setBootstrapping] = useState(() => localStorage.getItem(PERMISSIONS_BOOTSTRAP_KEY) === '1');

  useEffect(() => {
    const onPermissionsUpdated = () => {
      setBootstrapping(false);
      forceUpdate((value) => value + 1);
    };
    const timer = window.setTimeout(() => setBootstrapping(false), 4000);
    window.addEventListener(PERMISSIONS_UPDATED_EVENT, onPermissionsUpdated);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener(PERMISSIONS_UPDATED_EVENT, onPermissionsUpdated);
    };
  }, []);

  // المطلوب: إذا ما تم تمرير page/anyOf استخدم المسار الحالي
  const rawRequired =
    (Array.isArray(page) ? page : [page]).filter(Boolean).length === 0 &&
    (anyOf || []).length === 0
      ? [location.pathname]
      : [...(Array.isArray(page) ? page : [page]), ...(anyOf || [])].filter(
          Boolean
        );

  let perms = [];
  try {
    perms = JSON.parse(localStorage.getItem('permissions') || '[]');
  } catch {
    perms = [];
  }

  const allowed =
    // System Admin (role_id = 1) bypasses every page check, mirroring the
    // backend `is_system_admin` safety net. Without this the admin can land
    // on /No-access if a freshly added page isn't yet in their cached
    // localStorage permissions array.
    isSystemAdminSession() ||
    isOwnerRouteAllowed(location.pathname) ||
    hasPagePermission(perms, rawRequired, location.pathname);

  const pending =
    !allowed &&
    Boolean(localStorage.getItem('role_id')) &&
    (bootstrapping || localStorage.getItem(PERMISSIONS_BOOTSTRAP_KEY) === '1');

  if (pending) return null;

  return allowed ? (
    children
  ) : (
    <Navigate to="/No-access" replace state={{ from: location.pathname }} />
  );
}
